<template>
  <div class="flex flex-wrap items-start mb-4 pb-4">
    <div class="md:w-4/5 mb-3" v-if="parentType === 'SELECCION_CONDICIONAL'">
      <label
        class="block text-left pb-2 uppercase text-xs tracking-wider"
        for="condAnswer"
        >Respuesta asociada</label
      >
      <div class="relative">
        <select
          v-model="question.assignment"
          name="condAnswer"
          class="block appearance-none w-full border-2 bg-gray-200 border-orange-500 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-orange-300"
        >
          <option disabled selected>Seleccione una</option>
          <template v-for="(option, oIndex) in parentOptions">
            <option :key="'option' + oIndex" :value="option">
              {{ option }}
            </option>
          </template>
        </select>
        <div
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
        >
          <svg
            class="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            />
          </svg>
        </div>
      </div>
      <p
        v-if="question.assignmentError"
        class="text-red-500 text-xs italic text-left"
      >
        Debes seleccionar una respuesta asociada.
      </p>
    </div>
    <div class="md:w-4/5 flex flex-col">
      <span
        v-if="parentType !== 'SELECCION_CONDICIONAL'"
        class="text-left pb-2 uppercase text-xs tracking-wider"
        >Subpregunta {{ question.id_pregunta }}</span
      >
      <span v-else class="text-left pb-2 uppercase text-xs tracking-wider"
        >Subpregunta {{ question.id }}</span
      >
      <input
        :class="[errorBorderColor, borderColor]"
        class="bg-gray-200 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
        type="text"
        v-model="question.texto"
      />
      <p v-if="question.error" class="text-red-500 text-xs italic text-left">
        Ingrese la pregunta.
      </p>
    </div>
    <div class="md:w-1/5 flex justify-center">
      <button
        type="button"
        class="flex items-center px-2 py-1 rounded bg-red-500 text-gray-100 hover:bg-red-700"
        @click="remove"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 fill-current"
          viewBox="0 0 24 24"
        >
          <path
            d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
    </div>
    <div class="w-full flex items-center mt-3">
      <span class="text-left uppercase text-xs tracking-wider"
        >Nota para el registrante</span
      >
    </div>
    <div class="w-full flex flex-wrap mt-3">
      <input
        :class="borderColor"
        class="bg-gray-200 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
        type="text"
        v-model="question.nota_para_registrante"
      />
    </div>
    <div class="w-full flex items-center mt-3">
      <span class="text-left uppercase text-xs tracking-wider">Campos</span>
      <button
        type="button"
        class="flex items-center px-2 py-2 ml-2 rounded-full bg-gray-700 text-gray-100 hover:bg-gray-900"
        @click="addField"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 fill-current"
          viewBox="0 0 24 24"
        >
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
      <p
        v-if="question.fieldError"
        class="ml-3 text-red-500 text-xs italic text-left"
      >
        Deben llenarse todos los campos.
      </p>
      <p
        v-if="question.minimumError"
        class="ml-3 text-red-500 text-xs italic text-left"
      >
        Debe haber al menos un campo.
      </p>
    </div>
    <div class="w-full flex flex-wrap mt-3">
      <div
        v-for="(field, index) in question.campos"
        :key="index"
        class="relative w-1/3 pr-2 py-2"
      >
        <input
          :class="[
            {
              'border-red-500': field.texto === '' && question.optionError,
            },
            borderColor,
          ]"
          class="bg-gray-200 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
          type="text"
          v-model="question.campos[index].texto"
        />
        <button
          type="button"
          class="absolute top-0 right-0 flex items-center px-1 py-1 -mt-1 rounded-full border-2 border-gray-500 bg-gray-700 text-gray-100 hover:bg-gray-900"
          @click="removeField(index)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fields-subquestion",
  data() {
    return {};
  },
  components: {},
  methods: {
    remove() {
      this.$emit("click");
    },
    addField() {
      let field = {
        texto: "",
        tipo: "texto",
      };
      this.question.campos.push(field);
      this.question.minimumError = false;
    },
    removeField(index) {
      if (this.question.campos.length > 1) {
        this.question.campos.splice(index, 1);
        this.question.minimumError = false;
      } else {
        this.question.minimumError = true;
      }
    },
    validateQuestion() {
      this.question.minimumError = false;
      if (
        this.validateEmptyQuestion() &
        this.validateFields() &
        this.validateAssignment()
      ) {
        return true;
      } else {
        return false;
      }
    },
    validateEmptyQuestion() {
      if (this.question.texto === "") {
        this.question.error = true;
        return false;
      } else {
        this.question.error = false;
        return true;
      }
    },
    validateFields() {
      let emptyFields = this.question.campos.filter(
        (field) => field.texto === ""
      );
      if (emptyFields.length > 0) {
        this.question.fieldError = true;
        return false;
      } else {
        this.question.fieldError = false;
        return true;
      }
    },
    validateAssignment() {
      if (this.parentType === "SELECCION_CONDICIONAL") {
        if (
          this.question.assignment === "" ||
          this.question.assignment === undefined
        ) {
          this.question.assignmentError = true;
          return false;
        } else {
          this.question.assignmentError = false;
          return true;
        }
      } else {
        return true;
      }
    },
  },
  props: {
    question: {
      required: true,
    },
    color: {
      required: true,
    },
    parentType: {
      required: true,
    },
    parentOptions: {
      required: true,
    },
  },
  computed: {
    errorBorderColor() {
      return {
        "border-red-500": this.question.error,
      };
    },
    borderColor() {
      return {
        "border-teal-500 focus:border-teal-300": this.color === "teal",
        "border-indigo-500 focus:border-indigo-300": this.color === "indigo",
        "border-orange-500 focus:border-orange-300": this.color === "orange",
      };
    },
  },
};
</script>

<style scoped></style>
